var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"no-margins"},[_c('ActionButton',{staticClass:"mt-4",attrs:{"actionIcon":"$sl-password-type","href":"https://byn2.byn.se/sign_in"}},[_vm._v(" "+_vm._s(_vm.$t('labels.login-byn2'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }